import React, { useState, useEffect } from 'react';
import ReactApexChart from 'react-apexcharts';
import './styles.scss';
import DashboardService from 'services/dashboard-service';
import lib from 'helpers/lib';
import Skeleton from 'react-loading-skeleton';

export default function DesempenhoDiario({ representadaId, vendedorId, mes, ano, triggerFilters, onDoneFiltering }){

  const filtroMesAtual = new Date().getMonth() + 1 === mes && new Date().getFullYear() === ano;
  const diaAtual = filtroMesAtual ? new Date().getDate() : new Date(ano, mes, 0).getDate();
  const mesAtual = mes;

  const [chartOptions, setChartOptions] = useState({
    chart: {
      id: 'basic-bar',
      toolbar: {
        show: true,
        offsetX: 0,
        offsetY: 0,
        tools: {
          download: true,
          selection: true,
          zoom: true,
          zoomin: true,
          zoomout: true,
          pan: true,
          reset: true | '<img src="/static/icons/reset.png" width="20">',
          customIcons: []
        }
      }
    },
    colors: ['#1244b7', '#4ebcec'],
    dataLabels: {
      enabled: true,
      formatter: function (val) {
        return Math.round(val).toLocaleString('pt-BR');
      },
      style: {
        colors: ['#000000']
      },
      background: {
        enabled: true
      },
    },
    legend: {
      show: true,
      showForSingleSeries: false,
      showForNullSeries: true,
      showForZeroSeries: true,
      position: 'top',
      horizontalAlign: 'center',
      fontSize: '18px',
      fontFamily: 'Helvetica, Arial',
      itemMargin: {
        horizontal: 15,
        vertical: 0
      }
    },
    tooltip: {
      shared: true,
      y: {
        formatter: function (val) {
          return Math.round(val).toLocaleString('pt-BR') + " Kg";
        }
      },
      intersect: false,
      followCursor: true,
      custom: function ({ series, seriesIndex, dataPointIndex, w }) {

        let mesAnterior = w.globals.initialSeries[0].data[dataPointIndex];
        let mesAtual = w.globals.initialSeries[1].data[dataPointIndex];

        let anterior = Math.round(mesAnterior.y).toLocaleString('pt-BR');
        let atual = Math.round(mesAtual.y).toLocaleString('pt-BR');

        return `<div class="arrow_box">
          <p>Mês Atual: ${atual} Kg</p>
          <p>Mês Anterior: ${anterior} Kg</p>
        </div>`;
      }
    },
    plotOptions: {
      bar: {
        columnWidth: '70%',
        dataLabels: {
          position: 'top'
        }
      }
    },
    stroke: {
      width: [4, 0, 0]
    },
    markers: {
      size: 6,
      strokeWidth: 3,
      fillOpacity: 0,
      strokeOpacity: 0,
      hover: {
        size: 8
      }
    },
    // xaxis: {
    //   categories: []
    // },
    yaxis: {
      labels: {
        formatter: function (val) {
          return Math.round(val).toLocaleString('pt-BR');
        }
      }
    },
    labels: {
      formatter: (value) => {
        return `${value}`;
      }
    }
  });

  const [cards, setCards] = useState({});
  const [series, setSeries] = useState([]);
  const [isLoading, setIsLoading] = useState(false);

  const mesesPT = {
    Jan: "Jan",
    Feb: "Fev",
    Mar: "Mar",
    Apr: "Abr",
    May: "Mai",
    Jun: "Jun",
    Jul: "Jul",
    Aug: "Ago",
    Sep: "Set",
    Oct: "Out",
    Nov: "Nov",
    Dec: "Dez"
  };

  function seriesData(item, dataType) {
    let series = [];

    if (item.length > 0) {
      series = [
        {
          name: "Mês Anterior",
          type: 'column',
          data: item.map((p) => (
            {
              x: p.nomeCategoria,
              y: p.volumeMesAnterior,
              isCurrency: false,
              isVolume: dataType === 'volume'
            }
          ))
        },
        {
          name: "Mês Atual",
          type: 'column',
          data: item.map((p) => (
            {
              x: p.nomeCategoria,
              y: p.volumeMesAtual,
              isCurrency: false,
              isVolume: dataType === 'volume'
            }
          ))
        },
      ];
    }

    return series;
  }

  async function fetchCardsData(){
    setIsLoading(true);

    let filter = {
      representadaIds: [representadaId],
      vendedorId: vendedorId,
      mes: mes,
      ano: ano,
    };

    const response = await DashboardService.getCardsDesempenhoDiario(filter);

    if(response?.data){
      setCards(response.data.data);
      setSeries(seriesData(response.data.data.volumesPorCategoria, 'volume'));
      onDoneFiltering();
    }

    setIsLoading(false);
  }

  const meta = cards?.positivacao?.quantidadeCarteira ?? 0;

  const categorias = cards?.positivacao?.pedidosUltimos6Meses?.map(p => mesesPT[p.nomeMes]) ?? [];

  const seriePedidos = cards?.positivacao?.pedidosUltimos6Meses?.map(p => parseInt(p.quantidade || 0)) ?? [];

  const options = {
        chart: {
        id: "pedidos-6-meses",
        toolbar: { show: false }
        },
        stroke: {
        curve: "straight",
        width: 3
        },
        markers: {
        size: 5
        },
        xaxis: {
        categories: categorias
        },
        yaxis: {
          min: 0,
          decimalsInFloat: 0,
          labels: {
            formatter: (val) => parseInt(val)
          }
        },
        dataLabels: {
        enabled: true,
        formatter: (val) => parseInt(val)
        },
        tooltip: {
          y: {
            formatter: (val) => parseInt(val)
          }
        },
        colors: ["#0d6efd"],
        annotations: {
    }
  };

  const seriesOptionPedido = [
    {
    name: "Clientes",
    data: seriePedidos
    }
  ];
 

  useEffect(() => {
      (async () => {
        if(triggerFilters && !isLoading){
          await fetchCardsData();
        }
      })();
    }, [triggerFilters, onDoneFiltering]);

  return(
    <div className='row align-items-stretch'>
      <div className="col-6 d-flex mb-3">
        <div className="card-dash mb-3">
          <h4 className='fw-700'>Faturamento</h4>

            {!isLoading ? (
              <div className="card-container">
                <div className="row mt-3">
                  <div className="col-4">
                    <span className='d-block fw-700'>
                      Faturado: {(cards?.faturamento?.valorFaturado)?.toLocaleString('pt-br', {
                        style: 'currency',
                        currency: 'BRL',
                        maximumFractionDigits: 0
                      })}
                    </span>

                    <span className='d-block fw-700'>
                      Pedido: {(cards?.faturamento?.valorPedido)?.toLocaleString('pt-br', {
                        style: 'currency',
                        currency: 'BRL',
                        maximumFractionDigits: 0
                      })}
                    </span>
                  </div>

                  <div className="col-4">
                    <span className='d-block fw-700'>
                      Falta: {(cards?.faturamento?.valorMeta - cards?.faturamento?.valorPedido >= 0 ? cards?.faturamento?.valorMeta - cards?.faturamento?.valorPedido : 0)?.toLocaleString('pt-br', {
                        style: 'currency',
                        currency: 'BRL',
                        maximumFractionDigits: 0
                      })}
                    </span>

                    <span className='d-block fw-700'>
                      Em Carteira: {(cards?.faturamento?.valorPedido - cards?.faturamento?.valorFaturado >= 0 ? cards?.faturamento?.valorPedido - cards?.faturamento?.valorFaturado : 0)?.toLocaleString('pt-br', {
                        style: 'currency',
                        currency: 'BRL',
                        maximumFractionDigits: 0
                      })}
                    </span>
                  </div>

                  <div className="col-4 item-direita">
                    <span className='d-block fw-700'>Meta: {"\t"}
                      {(cards?.faturamento?.valorMeta)?.toLocaleString('pt-br', {
                        style: 'currency',
                        currency: 'BRL',
                        maximumFractionDigits: 0
                      })}
                    </span>
                  </div>
                </div>

                <div className="row mt-2">
                  <div className="col-12">
                    <div className="progress progress-sm mr-2">
                      <div
                        className="progress-bar progress-faturado bg-faturado"
                        role="progressbar"
                        style={{ width: `${cards?.faturamento?.porcentagemFaturado}%` }}
                        aria-valuenow={cards?.faturamento?.porcentagemFaturado}
                        aria-valuemin="0"
                        aria-valuemax="100"
                      ></div>

                      {/* <div
                        className="progress-bar bg-primary progress-pedido bg-pedido"
                        role="progressbar"
                        style={{ width: `${cards?.faturamento?.porcentagemPedido}%` }}
                        aria-valuenow={cards?.faturamento?.porcentagemPedido}
                        aria-valuemin="0"
                        aria-valuemax="100"
                      ></div> */}

                      <div
                        className="progress-bar progress-em-carteira bg-em-carteira"
                        role="progressbar"
                        style={{ width: `${ cards?.faturamento?.porcentagemEmCarteira}%` }}
                        aria-valuenow={ cards?.faturamento?.porcentagemEmCarteira}
                        aria-valuemin="0"
                        aria-valuemax="100"
                      ></div>
                    </div>
                  </div>
                </div>

                <div className="row mt-2">
                  <div className="col-4 d-flex align-items-center">
                    <div className="circle-item circle-faturado bg-faturado"></div>
                    <span>{Math.round(cards?.faturamento?.porcentagemFaturado, 2)}% Faturado</span>
                  </div>

                  {/* <div className="col-4 d-flex align-items-center justify-content-center">
                    <div className="circle-item circle-pedido bg-pedido"></div>
                    <span>{Math.round(cards?.faturamento?.porcentagemPedido, 2)}% Pedido</span>
                  </div> */}

                  <div className="col-8 d-flex justify-content-end align-items-center">
                    <div className="circle-item circle-em-carteira bg-em-carteira"></div>
                    <span>{Math.round(cards?.faturamento?.porcentagemEmCarteira, 2)}% Em Carteira</span>
                  </div>
                </div>
            </div>
          ) : <Skeleton Skeleton count={5} width={'100%'} height={20} />}
        </div>
      </div>

      <div className="col-6 d-flex mb-3">
        <div className="card-dash mb-3">
          <h4 className='fw-700'>Volume</h4>

          {!isLoading ? (
            <div className="card-container">
              <div className="row mt-3">
                <div className="col-4">
                  <span className='d-block fw-700'>
                    Faturado: {lib.formatToNumeric(cards?.volume?.volumeFaturado, 3, true)} Kg
                  </span>

                  <span className='d-block fw-700'>
                    Pedido: {lib.formatToNumeric(cards?.volume?.volumePedido, 3, true)} Kg
                  </span>
                </div>

                <div className="col-4">
                  <span className='d-block fw-700'>
                    Falta: {cards?.volume?.volumeMeta - cards?.volume?.volumePedido >= 0 ? lib.formatToNumeric(cards?.volume?.volumeMeta - cards?.volume?.volumePedido, 3, true) : 0} Kg
                  </span>

                  <span className='d-block fw-700'>
                    Em Carteira: {cards?.volume?.volumePedido - cards?.volume?.volumeFaturado >= 0 ? lib.formatToNumeric(cards?.volume?.volumePedido - cards?.volume?.volumeFaturado, 3, true) : 0} Kg
                  </span>
                </div>

                <div className="col-4 item-direita">
                  <span className='d-block fw-700'>Meta: {"\t"}
                    {lib.formatToNumeric(cards?.volume?.volumeMeta, 3, true)} Kg
                  </span>
                </div>
              </div>

              <div className="row mt-2">
                <div className="col-12">
                  <div className="progress progress-sm mr-2">
                    <div
                      className="progress-bar progress-faturado bg-faturado"
                      role="progressbar"
                      style={{ width: `${cards?.volume?.porcentagemFaturado}%` }}
                      aria-valuenow={cards?.volume?.porcentagemFaturado}
                      aria-valuemin="0"
                      aria-valuemax="100"
                    ></div>

                    {/* <div
                      className="progress-bar progress-pedido bg-pedido"
                      role="progressbar"
                      style={{ width: `${cards?.volume?.porcentagemPedido}%` }}
                      aria-valuenow={cards?.volume?.porcentagemPedido}
                      aria-valuemin="0"
                      aria-valuemax="100"
                    ></div> */}

                    <div
                      className="progress-bar progress-em-carteira bg-em-carteira"
                      role="progressbar"
                      style={{ width: `${cards?.volume?.porcentagemEmCarteira}%` }}
                      aria-valuenow={cards?.volume?.porcentagemEmCarteira}
                      aria-valuemin="0"
                      aria-valuemax="100"
                    ></div>
                  </div>
                </div>
              </div>

              <div className="row mt-2">
                <div className="col-4 d-flex align-items-center">
                  <div className="circle-item circle-faturado bg-faturado"></div>
                  <span>{Math.round(cards?.volume?.porcentagemFaturado, 2)}% Faturado</span>
                </div>

                {/* <div className="col-4 d-flex align-items-center justify-content-center">
                  <div className="circle-item circle-pedido bg-pedido"></div>
                  <span>{Math.round(cards?.volume?.porcentagemPedido, 2)}% Pedido</span>
                </div> */}

                <div className="col-8 d-flex justify-content-end align-items-center">
                  <div className="circle-item circle-em-carteira bg-em-carteira"></div>
                  <span>{Math.round(cards?.volume?.porcentagemEmCarteira, 2)}% Em Carteira</span>
                </div>
              </div>
            </div>
          ) : <Skeleton Skeleton count={5} width={'100%'} height={20} />}
        </div>
      </div>

      <div className="col-6 d-flex mb-3">

          <div className="card-dash mb-3">
          <h4 className="fw-700">Positivação últimos 6 meses</h4>

          {!isLoading ? (
            <div>
              <ReactApexChart
                options={options}
                series={seriesOptionPedido}
                type="line"
                height={160}
              />

              <div className="mt-3">
                <strong>Minha carteira atual:</strong> {meta} clientes
              </div>
            </div>
          ) : <Skeleton Skeleton count={5} width={'100%'} height={20} />}
        </div>
      </div>

      <div className="col-6 d-flex mb-3">
        <div className="card-dash mb-3 d-flex flex-column h-100">
          <h4 className='fw-700'>Performance (Até dia {diaAtual})</h4>

          {!isLoading ?(
            <div className="card-container d-flex flex-column justify-content-between flex-grow-1">
              <div>
                <div className="row">
                  <div className="col-12 d-flex justify-content-between mt-4">
                    <span className='fw-600'>{lib.selectListMeses.find(m => m.value === mesAtual)?.label} (Até dia {diaAtual})</span>
                    <span className='text-end d-flex align-items-center'>
                      Ritmo: {cards?.performance?.porcentagemRitmoMesAtual}%
                      <div className="circle-item ml-2 circle-performance-atual"></div>
                    </span>
                  </div>

                  <div className="col-12">
                    <div className="progress progress-sm mr-2">
                      <div
                        className="progress-bar circle-performance-atual"
                        role="progressbar"
                        style={{ width: `${(cards?.performance?.porcentagemRitmoMesAtual)}%` }}
                        aria-valuenow={(cards?.performance?.porcentagemRitmoMesAtual)}
                        aria-valuemin="0"
                        aria-valuemax="100"
                      >
                      </div>
                    </div>
                  </div>

                  <div className="col-8">
                    <span>
                      Média Diária: {"\t"}
                      {(cards?.performance?.mediaDiariaMesAtual)?.toLocaleString('pt-br', {
                        style: 'currency',
                        currency: 'BRL',
                        maximumFractionDigits: 0
                      })}/dia
                    </span>
                    <span>
                      {"\t"}(Faturado:
                      {(cards?.performance?.valorFaturadoMesAtual)?.toLocaleString('pt-br', {
                        style: 'currency',
                        currency: 'BRL',
                        maximumFractionDigits: 0
                      })})
                    </span>
                  </div>

                  <div className="col-4 item-direita">
                    <span>Meta:{"\t"}
                      {(cards?.performance?.metaDiariaMesAtual)?.toLocaleString('pt-br', {
                        style: 'currency',
                        currency: 'BRL',
                        maximumFractionDigits: 0
                      })}/dia
                    </span>
                  </div>
                </div>
              </div>
              <div>
                <div className="row">
                  <div className="col-12 d-flex justify-content-between mt-4">
                    <span className='fw-600'>{lib.selectListMeses.find(m => m.value === mesAtual - 1)?.label}
                      {/* Até dia {diaAtual}) */}
                    </span>
                    <span className='text-end d-flex align-items-center'>
                      Ritmo: {cards?.performance?.porcentagemRitmoMesAnterior}%
                      <div className="circle-item ml-2 circle-performance-anterior"></div>
                    </span>
                  </div>

                  <div className="col-12">
                    <div className="progress progress-sm mr-2">
                      <div
                        className="progress-bar circle-performance-anterior"
                        role="progressbar"
                        style={{ width: `${(cards?.performance?.porcentagemRitmoMesAnterior)}%` }}
                        aria-valuenow={(cards?.performance?.porcentagemRitmoMesAnterior)}
                        aria-valuemin="0"
                        aria-valuemax="100"
                      >
                      </div>
                    </div>
                  </div>

                  <div className="col-10">
                    <span>
                      Média Diária: {"\t"}
                      {(cards?.performance?.mediaDiariaMesAnterior)?.toLocaleString('pt-br', {
                        style: 'currency',
                        currency: 'BRL',
                        maximumFractionDigits: 0
                      })}/dia
                    </span>
                    <span>
                      {"\t"}(Faturado:
                      {(cards?.performance?.valorFaturadoMesAnterior)?.toLocaleString('pt-br', {
                        style: 'currency',
                        currency: 'BRL',
                        maximumFractionDigits: 0
                      })})
                    </span>
                  </div>

                  {/* <div className="col-2">
                    <span>Meta:
                      {(cards?.performance?.metaDiaria).toLocaleString('pt-br', {
                        style: 'currency',
                        currency: 'BRL',
                        maximumFractionDigits: 0
                      })}
                    </span>
                  </div> */}
                </div>
              </div>

            </div>
          ) : <Skeleton Skeleton count={5} width={'100%'} height={20} />}
        </div>
      </div>

      <div className="col-12">
        <div className="card-dash mb-3">
          <div className="dashboard-bar-chart">
            <div id="bar-chart">
              <div className="grafico-titulo text-center ">
                <h4>Volume por Categoria</h4>
              </div>
      
              {!isLoading ? (
                <ReactApexChart
                  height="400"
                  type="bar"
                  options={chartOptions}
                  series={series}
                />
              ) : (
                <Skeleton count={10} width={'100%'} height={20} />
              )}
            </div>
          </div>
        </div>
      </div>
    </div>
  );
}